export default {
  slug: 'glossary',
  title: 'Glossary',
  description: 'Terms used across the platform.',
  section: 'reference',
  order: 3,
  tags: ['glossary', 'terms', 'definitions'],
  body: `# Glossary

## A

**Actor** — Threat actor record linked to cases; attribution target for indicators and timeline events.

**Audit log** — Immutable record of platform actions for compliance and handoffs.

## C

**Case** — Primary investigation container with timeline, notes, IOCs, personas, and evidence.

**Celery** — Background task runner used for async intelligence enrichment.

## E

**EntityLink** — Stored relationship between two platform entities with a typed relation.

**Enrichment** — Automated OSINT collection (DNS, WHOIS, geo, panel fingerprint, etc.) for a search input.

**Evidence** — Quarantined artifact with metadata and optional case linkage.

## I

**Indicator (IOC)** — Normalized observable in the platform registry (IP, domain, email, wallet, …).

**Implicit link** — Relationship inferred by the platform (e.g. indicator → case via foreign key) without a stored EntityLink row.

## P

**Persona** — Controlled identity used in authorized engagement.

**Pivot** — Navigate to a related entity via clickable link or graph node.

**Promote** — Convert a search result or extracted IOC into a registered indicator.

## S

**Search** — Intelligence enrichment run with status, enrichments JSON, and optional promotion.

**Hivemind Subterfuge Platform** — Unified Cipher Cortex workspace for enrichment, cases, personas, evidence, and engagement.
`,
};
